// example theme file
const theme = {
  colors: {
    text: "#000",
    background: "#fff",
    backgroundLight: "#E7DEDB",
    backgroundDark: "#E7DEDB",
    primary: "#EA5297",
    primaryLight: "#EA5297",
    primaryDark: "#C72C6B",
    secondary: "#602483",
    white: "#fff",
    headerBg: "#E7DEDB",
    headerText: "#000",
    menuBorderColor: "#fff",
    success: "#7DBE31",
    error: "#EC1818",
  },
  fonts: {
    body: "sans-serif",
    heading: "sans-serif",
    monospace: "monospace",
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  sizes: {
    container: 1320,
    heroContent: 960,
    headerHeight: 80,
    headerLogoHeight: 80,
    subMenuHeight: 60,
  },
  breakpoints: [`480px`, `768px`, `900px`, `1200px`, `1600px`],
  text: {
    caps: {
      textTransform: "uppercase",
    },
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
    },
    title: {
      variant: `text.caps`,
      color: `primary`,
      fontSize: 4,
      marginBottom: 3,
    },
    underlined: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "1.5rem",

      "&::after": {
        content: '""',
        display: "block",
        width: "50%",
        height: "2px",
        background: "primary",
        marginTop: "1rem",
      },
    },
    boxed: {
      display: "inline-block",
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "background",
      bg: "secondary",
      p: 3,
      my: 4,
    },
    nav: {
      textDecoration: "none",
      color: "text",
      "&.active": {
        color: "primary",
      },
    },
  },
  forms: {
    input: {
      borderColor: "secondary",
      borderRadius: 0,
      fontFamily: "body",
      p: `10px`,
    },
    textarea: {
      borderColor: "secondary",
      borderRadius: 0,
      fontFamily: "body",
      p: `10px`,
    },
    select: {
      backgroundColor: "backgroundDark",
      borderColor: "primary",
      borderRadius: 0,
      color: "white",
      display: "inline-block",
      width: "auto",
      paddingX: 4,
      paddingY: 3,
      cursor: "pointer",

      secondary: {
        backgroundColor: "transparent",
        borderColor: "secondary",
        borderRadius: 0,
        fontFamily: "body",
        p: `10px`,
      },
    },
  },
  styles: {
    root: {
      margin: 0,
      padding: 0,
      boxSizing: `border-box`,
      textRendering: `optimizeLegibility`,
      WebkitFontSmoothing: `antialiased`,
      MozOsxFontSmoothing: `grayscale`,
      color: `text`,
      backgroundColor: `background`,
      fontFamily: "body",
      fontWeight: "body",
      maxWidth: "100vw",
      overflowX: "hidden",
      a: {
        color: `primary`,
        textDecoration: `none`,
        transition: `all 0.3s ease-in-out`,
        "&:hover": {
          color: `primary`,
          textDecoration: `none`,
        },
      },
      p: {
        fontSize: [0, 1, 2],
        letterSpacing: `-0.003em`,
        lineHeight: `body`,
        "--baseline-multiplier": 0.179,
        "--x-height-multiplier": 0.35,
        color: `text`,
      },
      h1: {
        variant: "text.heading",
        fontSize: [4, 5, 6],
      },
      h2: {
        variant: "text.heading",
        fontSize: [4, 5, 6],
        position: "relative",
      },
      h3: {
        variant: "text.heading",
        fontSize: [3, 4, 5],
        padding: 0,
        margin: 0,
        position: "relative",
      },
      h4: {
        variant: "text.heading",
        fontSize: [2, 3, 4],
        marginY: 2,
      },
      blockquote: {
        marginLeft: 0,
        p: {
          fontSize: [2, 3],
          fontWeight: `medium`,
          color: `heading`,
        },
      },
      ul: {
        display: `inline-block`,
      },
      img: {
        maxWidth: `100%`,
        height: `auto`,
      },
    },
  },
  layout: {
    container: {
      py: 5,
      px: 3,
    },
    cta: {
      backgroundColor: "backgroundLight",
      textAlign: "center",
      h2: {
        marginTop: 0,
      },
      p: {
        color: "inherit",
      },
      a: {
        borderColor: "inherit",
        color: "inherit",
      },
    },
    nav: {
      gap: 3,
    },
  },
  buttons: {
    primary: {
      color: "background",
      bg: "primary",
      paddingX: 4,
      paddingY: 3,
      borderRadius: 0,
      cursor: "pointer",
      "&:hover, &:focus, &:active": {
        color: "background",
        bg: "primary",
        transform: "scale(1.1)",
      },
    },
    secondary: {
      color: "text",
      bg: "transparent",
      border: "1px solid",
      paddingX: 4,
      paddingY: 3,
      borderRadius: 0,
      cursor: "pointer",
      "&:hover, &:focus, &:active": {
        borderColor: "inherit",
        color: "inherit",
        transform: "scale(1.1)",
      },
    },
    toggle: {
      color: `background`,
      border: `none`,
      backgroundColor: `text`,
      cursor: `pointer`,
      alignSelf: `center`,
      px: 3,
      py: 2,
      ml: 3,
    },
  },
  container: {
    small: {
      maxWidth: `960px`,
    },
  },
};

export default theme;
